import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';
import type { DirectionalTrafficResponse } from '../types/directional-traffic.types';

export const fetchDirectionalTraffic = async (params = ''): Promise<DirectionalTrafficResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.directionalTraffic(params)}`;
  try {
    const response = await request.get<DirectionalTrafficResponse>(url);
    return response;
  } catch (error) {
    console.error('Error fetching directional traffic:', error);
    throw error;
  }
};
